import _ from 'lodash';
import Vue from 'vue';
import moment from 'moment';
import { HTTP } from '@/utils/http';
import * as actions from '../types/actions';
import * as getters from '../types/getters';
import * as mutations from '../types/mutations';

const defaultDates = [
  moment().startOf('year').toDate(),
  moment().endOf('year').toDate(),
];

const defaultFilters = {
  dates: [],
};

export default {
  actions: {
    async [actions.DO_CREATE_MEDIA_IMAGE]({ commit }, payload) {
      const { data } = await HTTP.post('/media/images', payload);
      commit(mutations.SET_MEDIA, data.data.images[0]);
      return data;
    },
    async [actions.DO_CREATE_MEDIA_VIDEO]({ commit }, payload) {
      const { data } = await HTTP.post('/media/videos', payload);
      commit(mutations.SET_MEDIA, data.data.videos[0]);
      return data;
    },
    async [actions.DO_DELETE_MEDIA]({ commit }, payload) {
      const { id } = payload;
      const params = Object.assign({}, payload);
      delete params.id;
      const { data } = await HTTP.delete(`/media/${id}`, params);
      return data;
    },
  },
  getters: {
    [getters.GET_MEDIA_FILTERS]: state => state.filters,
    [getters.GET_MEDIA_REFRESH]: state => state.refresh,
    [getters.GET_MEDIA_TAB]: state => state.tab,
    [getters.GET_MEDIA_TAGS]: state => state.tags,
  },
  mutations: {
    [mutations.SET_MEDIA](state, media) {
      state.media = media;
    },
    [mutations.SET_MEDIA_FILTER_DEFAULT_DATES](state) {
      Vue.set(state.filters, 'dates', _.cloneDeep(defaultDates));
    },
    [mutations.SET_MEDIA_FILTER_FIELD](state, field) {
      const nodes = field.key.split('.');
      let obj = state.filters;
      let i = 0;
      nodes.forEach((node) => {
        i += 1;
        if (i === nodes.length) {
          Vue.set(obj, node, field.val);
        } else {
          obj = obj[node];
        }
      });
    },
    [mutations.SET_MEDIA_REFRESH](state, refresh) {
      state.refresh = refresh;
    },
    [mutations.SET_MEDIA_TAB](state, tab) {
      state.tab = tab;
    },
    [mutations.TOGGLE_MEDIA_TAG](state, tag) {
      const index = _.findIndex(state.tags, { _id: tag._id });
      if (index < 0) {
        state.tags.push(tag);
      } else {
        state.tags.splice(index, 1);
      }
    },
  },
  state: {
    media: {},
    filters: _.cloneDeep(defaultFilters),
    refresh: false,
    tab: 'episodes',
    tags: [],
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/media.js